var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import PropTypes from "prop-types";
import Typography from "../Typography";
export var Badge = function (_a) {
    var _b;
    var label = _a.label, _c = _a.className, className = _c === void 0 ? "" : _c, props = __rest(_a, ["label", "className"]);
    var classNames = classnames((_b = {
            "mex-badge": true,
            "mex-badge--numeric": !!label
        },
        _b[className] = className,
        _b));
    return (_jsx("span", __assign({ className: "mex-badge-wrapper" }, { children: _jsx("span", __assign({ className: classNames }, props, { children: label && (_jsx(Typography, __assign({ variant: "metadataRegular", className: "mex-badge__label" }, { children: label }))) })) })));
};
Badge.propTypes = {
    className: PropTypes.string,
    label: PropTypes.number,
};
export default Badge;
